import { Loading } from '.';
import clsx from 'clsx';
import { useAtomValue } from 'jotai';
import { pageLoadingAtom } from '../atoms/system';

const PageLoading = (): JSX.Element => {
  const show = useAtomValue(pageLoadingAtom);
  return (
    <div
      className={clsx(
        show ? '' : 'hidden',
        'fixed bg-white bg-opacity-80 top-0 left-0 right-0 bottom-0 flex justify-center items-center z-[99999]',
      )}
    >
      <Loading color="indigo-600" size={6} />
    </div>
  );
};
export default PageLoading;
